export const TIPI_INTERVENTO = [
  "Maltrattamento",
  "Abbandono",
  "Anagrafe Canina",
  "Avvelenamento",
  "Detenzione illecita",
  "Randagismo",
  "Altro",
];

export const STATI_VERBALE = [
  "In corso",
  "Verificato",
  "Trasmesso ASL/Procura",
  "Archiviato",
];

export function fmtDate(d) {
  if (!d) return "—";
  try {
    const only = d.includes("T") ? d.split("T")[0] : d;
    const [y, m, g] = only.split("-");
    if (y && m && g) return `${g}/${m}/${y}`;
    return d;
  } catch {
    return d;
  }
}

const IT_DT = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });

export function fmtDateTime(d) {
  if (!d) return "—";
  try {
    if (/T.*(Z|[+-]\d{2}:?\d{2})$/.test(d)) {
      const p = Object.fromEntries(IT_DT.formatToParts(new Date(d)).map((x) => [x.type, x.value]));
      return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}`;
    }
    const [datePart, timePart] = d.split("T");
    const [y, m, g] = datePart.split("-");
    const t = timePart ? timePart.slice(0, 5) : "";
    return `${g}/${m}/${y}${t ? " " + t : ""}`;
  } catch {
    return d;
  }
}
